import React, { useState } from "react";

import classes from "../../JournalFeed.scss";

import { Alert, Button } from "@toddle-edu/ds-web";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const ApproveActionBar = props => {
  const {
    titleText,
    onCloseClick,
    onActionClick,
    state,
    message,
    isClosable = true,
    alertStyle,
  } = props;

  const { t } = useTranslation("journal");

  const actionBarStyle = {
    boxShadow: `0px 8px 16px 0px rgba(0, 0, 0, 0.10)`,
  };

  const [showReviewerActionBar, setShowReviewerActionBar] = useState(true);
  const onCloseClickLocal = () => {
    setShowReviewerActionBar(false);
  };

  const inapprovalActionElement = () => {
    return (
      <Button
        dsVersion="2.0"
        size="medium"
        variant="neutral"
        type="outlined"
        onClick={onActionClick}
      >
        <span className={classNames("text-label-3", classes.buttonText)}>
          {t("journal:approve_all")}
        </span>
      </Button>
    );
  };

  const inapprovalStaffActionElement = () => {
    const onActionClickLocal = state => () => {
      onActionClick({ action: state });
    };
    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          dsVersion="2.0"
          size="medium"
          variant="primary"
          onClick={onActionClickLocal("APPROVE")}
        >
          <span className={classNames("text-label-3", classes.buttonText)}>
            {t("journal:publish_all")}
          </span>
        </Button>
        <Button
          dsVersion="2.0"
          size="medium"
          variant="neutral"
          type="outlined"
          onClick={onActionClickLocal("DRAFT")}
        >
          <span className={classNames("text-label-3", classes.buttonText)}>
            {t("journal:move_all_posts_to_draft")}
          </span>
        </Button>
      </div>
    );
  };

  const getActionElement = type => {
    switch (type) {
      case "IN_APPROVAL":
        return inapprovalActionElement();
      case "IN_APPROVAL_STAFF":
        return inapprovalStaffActionElement();
      default:
        null;
    }
  };

  const isInapprovalStaffTab = state === "IN_APPROVAL_STAFF";

  return (!isInapprovalStaffTab ? true : showReviewerActionBar) ? (
    <div
      className={classes.postApprovalBar}
      style={{ ...alertStyle, left: "24px" }}
    >
      <Alert
        type={"info"}
        isClosable={true}
        title={titleText}
        dsVersion={"2.0"}
        style={actionBarStyle}
        onClose={
          state === "IN_APPROVAL_STAFF" ? onCloseClickLocal : onCloseClick
        }
        actionElement={getActionElement(state)}
        message={message}
        actionElementPosition={
          state === "IN_APPROVAL_STAFF" ? "bottom" : "right"
        }
        variant={"inline"}
      />
    </div>
  ) : null;
};

export default ApproveActionBar;
